import React from 'react';
import PropTypes from 'prop-types';
import {
  FaCalendarAlt,
  FaClinicMedical,
  FaHospital,
  FaUserInjured,
  FaExclamationCircle,
} from 'react-icons/fa';

const getIconForType = (tipo) => {
  switch (tipo) {
    case 'agenda':
      return (
        <FaCalendarAlt className="text-primary text-3xl" aria-label="Agenda" />
      );
    case 'atendimento':
      return (
        <FaClinicMedical
          className="text-green-500 text-3xl"
          aria-label="Atendimento"
        />
      );
    case 'clinica':
      return (
        <FaHospital className="text-red-500 text-3xl" aria-label="Clínica" />
      );
    case 'paciente':
      return (
        <FaUserInjured
          className="text-yellow-500 text-3xl"
          aria-label="Paciente"
        />
      );
    default:
      return (
        <FaExclamationCircle
          className="text-gray-500 text-3xl"
          aria-label="Outro"
        />
      );
  }
};

const TimelineItem = ({ item }) => (
  <div className="relative flex items-start mb-8" data-testid="timeline-item">
    {/* Linha central da timeline */}
    <div
      className="absolute left-7 top-8 h-full w-px bg-gray-300"
      data-testid="timeline-line"
    ></div>

    {/* Ícone do item */}
    <div
      className="relative z-10 bg-white p-3 rounded-full shadow-lg"
      data-testid="timeline-icon"
    >
      {getIconForType(item.tipo)}
    </div>

    {/* Conteúdo do item */}
    <div
      className="ml-8 p-4 bg-white shadow-md rounded-lg flex-1"
      data-testid="timeline-content"
    >
      <h3
        className="font-semibold text-dark-gray text-lg mb-1"
        data-testid="timeline-description"
      >
        {item.descricao}
      </h3>
      <p className="text-gray-600 mb-2" data-testid="timeline-details">
        {item.detalhes}
      </p>
      <p className="text-sm text-gray-400" data-testid="timeline-date">
        {`Data: ${item.data.toLocaleString()}`}
      </p>
    </div>

    {/* Informação útil à direita */}
    {/* <div className="ml-4 text-sm text-gray-600 flex-shrink-0 text-right">
      <p className="font-medium">{item.status || 'Status Desconhecido'}</p>
      <p className="text-xs">{item.duration || 'Duração não especificada'}</p>
    </div> */}
  </div>
);

TimelineItem.propTypes = {
  item: PropTypes.shape({
    tipo: PropTypes.string.isRequired,
    descricao: PropTypes.string.isRequired,
    detalhes: PropTypes.string,
    data: PropTypes.instanceOf(Date).isRequired,
  }).isRequired,
};

export default TimelineItem;
